import React, { useEffect, useState } from 'react';
import Container from '@/components/container';
import { QuestionCircleOutlined, EditOutlined, ProfileOutlined } from '@ant-design/icons';
import { Tooltip, message, Button } from 'antd';
import apis from '../apis';
import { Link } from 'react-router-dom';
import './index.less';
import ComponentLog from '@/components/component-log';

const ResourceList = () => {
  const [resourceList, setResourceList] = useState([]);
  // 请求资源位列表接口
  useEffect(() => {
    apis
      .getResourceState({ resourceFirstType: 1 })
      .then((res) => {
        if (res && res.ret === '0') {
          setResourceList(res.data.resourceStates);
        }
      })
      .catch((err) => {
        message.error(err);
      });
  }, []);

  return (
    <Container>
      <div className="resource-state-list-wrap">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className="resource-state-list-title">资源位列表</div>
          <Tooltip
            style={{ color: 'inherit' }}
            title="资源位列表主要集合了线上营销活动的前台露出位置，由特定的人进行管理和维护。"
            placement="top"
          >
            <QuestionCircleOutlined style={{ fontSize: '16px' }} />
          </Tooltip>
        </div>
        <div className="resource-state-item-wrap">
          {resourceList.length > 0 &&
            resourceList.map((item) => (
              <div className="resource-item" key={item.resourceStateCode}>
                <div className="item-title">{item.resourceName}</div>
                <div className="ID">资源位ID：{item.resourceStateCode}</div>
                <div className="btn-wrap">
                  <ComponentLog>
                    <Link
                      clstag="/resource_1627030927203|1"
                      to={`/material-manage/resource-list/publish?resourceStateCode=${item.resourceStateCode}`}
                      target="_blank"
                    >
                      <Button className="left-btn">
                        <EditOutlined style={{ marginRight: '6px' }} />
                        发布资源
                      </Button>
                    </Link>
                  </ComponentLog>
                  <ComponentLog>
                    <Link clstag="/resource_1627030927203|2" to="/material-manage/resource-manage" target="_blank">
                      <Button className="right-btn">
                        <ProfileOutlined style={{ marginRight: '6px' }} />
                        申请管理
                      </Button>
                    </Link>
                  </ComponentLog>
                </div>
              </div>
            ))}
          {resourceList.length < 3 && (
            <>
              <div className="resource-item empty">待开放 敬请期待</div>
              {/* <div className='resource-item empty'>待开放 敬请期待</div> */}
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ResourceList;
